<template>
  <div class="d-flex align-items-center mr-2">
      <div class="add-picture-gallery"
           @click="handleUpdateFile" >
          <i :class="loadingUploadImage
              ? 'fal fa-hourglass-half'
              : 'fal fa-file-image'"
              aria-hidden="true"
          ></i>
      </div>
        <carousel-3d
            :width="100"
            :height="100"
            :disable3d="false"
            :display="5"
            :loop="false"
            :space="87"
            :clickable="false"
            :perspective="0"
            :dir="'ltr'"
            :border="0"
            :startIndex="indexMainImageActiveElement"
            @after-slide-change="changePageCover"
            ref="coverPageSlider"
        >
            <slide
                v-for="(post, index) in slidesToShow"
                :key="index"
                :index="index"
                class="d-flex align-items-center"
            >
                <div v-show="imageView">
                    <BaseImage
                        customClass="rounded"
                        :source="post.mainImage"
                        :fitIn="'100x100'"
                    />
                    <button class="btn btn-block btn-primario px-2 py-0 position-absolute" @click="alertMessage = true" >
                        <i class="fal fa-trash-alt font-14"></i>
                    </button>
                </div>
            </slide>

        </carousel-3d>

        <div v-if="showMediaManager">
            <media-manager
                :picsInGallery="slidesToShow"
                :maxItemSelected="1"
                @receiveMedias="addPictures($event)"
                @closeTabs="closeTabs()"
            />
        </div>

        <AlertScreen :showAlertScreen="alertMessage" @returnAlertScreen="deletePhoto($event)"/>
    </div>
</template>

<script>
import BaseImage from "@/components/atoms/BaseImage";
import { Carousel3d, Slide } from "vue-carousel-3d";
import uploadFiles from "@/mixins/uploadFiles";
import AlertScreen from "@/components/molecules/AlertScreen.vue";
import MediaManager from '../organisms/MediaManager.vue';

export default {
    data(){
        return{
            uploadedPictures: [],
            loadingUploadImage: false,
            activeImage:'',
            showMediaManager: false,
            imageView: true,
            alertMessage: false,
        }
    },
    components:{
        Carousel3d,
        Slide,
        BaseImage,
        AlertScreen,
        MediaManager
    },
    mixins: [
        uploadFiles,
        ],
    props:{
        //Quantidade de imagens que podem ser enviadas
        quantityUploadFiles:{
            required:false,
            type:Number,
            default:200
        },
        // Array com posts (serão add as imagens ao carousel)
        getActivePosts: {
            required: true,
        },
        // Elemento que será editado a imagem padrão
        editableElement: {
            required: true,
        },
        //Imagem que está definida como padrão
        activeImg: {
            required: false,
        },
        trashView: {
            required: false,
            default: true,
        },
    },
    created(){
        if(this.activeImg){
            this.activeImage = this.activeImg
            this.uploadedPictures.push({
                    mainImage: this.activeImage,
                    });
            }
    },
    watch:{
        activeImg(){
            if(this.activeImg){
                this.activeImage = this.activeImg
                }
            }
    },
    computed: {
        slidesToShow() {
            let filterActivePagePosts = this.getActivePosts
            if(this.getActivePosts.length > 0 && this.getActivePosts[0].category) {
                filterActivePagePosts = this.getActivePosts.filter((post) =>
                    post.category.some((cat) => cat.id === this.editableElement.id)
                );
            }
            filterActivePagePosts = filterActivePagePosts.filter(
                (post) => post.mainImage != null
            );
            const slideItems = [
                ...this.uploadedPictures,
                ...filterActivePagePosts,
            ].flat();

            return slideItems;
        },
        indexMainImageActiveElement() {
            if(!this.editableElement.pixel) this.editableElement.pixel = null
            const indexMainImage = this.slidesToShow.findIndex(
                (slide) => slide.mainImage == this.activeImage);
            if(indexMainImage < 0 && this.activeImage ){
                this.uploadedPictures.push({
                mainImage: this.activeImg ,
                });
            }
            return indexMainImage >= 0 ? indexMainImage : 0;
        },
    },
    methods:{
        closeTabs() {
            this.loadingUploadImage = false;
            this.showMediaManager = false;
        },
        deletePhoto(event){
          this.alertMessage = false;
          if(event === 1) {
            this.imageView = false
            this.alertMessage = false;
            this.$emit('deletePhoto')
          }
        },
        addPictures(files){
            if (files) {
                this.activeImage = files[0].url
                this.uploadedPictures.unshift({
                    mainImage: files[0].url,
                })
                this.$refs.coverPageSlider.goSlide(0);
            } else {
                alert("Nenhum arquivo selecionado.");
            }
            this.showMediaManager = false
            this.loadingUploadImage = false;
        },
        changePageCover(indexCarouselPicture) {
            if (indexCarouselPicture < this.slidesToShow.length) {
                this.activeImage = this.slidesToShow[
                indexCarouselPicture
                ].mainImage;
            this.$emit('changeImage', this.activeImage)
            }
        },
        updateFile() {
            this.$refs.updateFile.click();
        },
        async handleUpdateFile() {
            this.loadingUploadImage = true;
            this.showMediaManager = true
        },
    }
}
</script>
<style scoped>
    .current img {
      border: 2px solid var(--main-color);
    }
    .item-settings-button {
      top: 5px;
      left: 55px;
      z-index: 999;
    }
    .add-picture-gallery {
        padding-top: 90px;
        width: 100px;
    }
    .carousel-3d-container{
        margin: auto;
        padding-left: 40px;
        display: inline-flex;
        align-items: center;
    }
    .carousel-3d-slider {
        margin: unset !important;
    }
    .btn-primario {
      top: 7%;
      left: 68%;
      width: 27px;
    }
</style>



// WEBPACK FOOTER //
// src/components/molecules/ImageCarousel.vue